import { type FirebaseStorage } from 'firebase/storage'
import { getContext, setContext } from 'svelte'

const storageContextKey = Symbol('storageContext')

export function setStorageContext(storage: FirebaseStorage) {
	setContext<FirebaseStorage>(storageContextKey, storage)
}

export function getStorageContext() {
	return getContext<FirebaseStorage>(storageContextKey)
}
